var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found",style:(_vm.style)},[_c('span',{staticClass:"emoji"},[_vm._v("😕")]),_c('span',{staticClass:"text"},[_vm._v("找不到資料")])])}
var staticRenderFns = []

export { render, staticRenderFns }